export default "__VITE_ASSET__BKNE_B5J__"